module.exports = __webpack_public_path__ + "media/images/emblems/Aedermannsdorf-blason-7d82b10524890759d63e482f8c3c8ef7.png";